

/**
 * @enum {string}
 */
export default {
  POLYGON: 'POLYGON',
  POLYLINE: 'POLYLINE',
  POINT: 'POINT'
};